"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const appSchema = 'bloomtext'; exports.appSchema = appSchema

 const BASE_APP_URL = 'https://app.bloomtext.com'; exports.BASE_APP_URL = BASE_APP_URL

 const MAX_PASSWORD_LENGTH = 72; exports.MAX_PASSWORD_LENGTH = MAX_PASSWORD_LENGTH
